import { render, staticRenderFns } from "./designCoordination.vue?vue&type=template&id=79f66dc2&scoped=true"
import script from "./designCoordination.vue?vue&type=script&lang=js"
export * from "./designCoordination.vue?vue&type=script&lang=js"
import style0 from "./designCoordination.vue?vue&type=style&index=0&id=79f66dc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f66dc2",
  null
  
)

export default component.exports